import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { GET_USER_PROFILE } from '../queries/userQueries';

import AddLikeButton from "./AddLikeButton";
import Comment from "./Comment";
import SavePostButton from "./SavePostButton";
import AddCommentButton from "./AddCommentButton";
import { GET_POST } from "../queries/postQueries";
import Spinner from "./Spinner";

export default function PostCard({ post }) {
  const navigate = useNavigate()
  const [showAllComments, setShowAllComments] = useState(false)
  const date = new Date(post.createdAt)

  const handleShowMoreComments = () => {
    setShowAllComments(!showAllComments)
  }

  const { loading: userLoading, error: userError, data: userData } = useQuery(GET_USER_PROFILE, {
    variables: { id: post.userId }
  })

  const { refetch } = useQuery(GET_POST, { variables: { id: post.id } })

  const comments = post.comments

  const commentsToShow = showAllComments ? comments : comments.slice(0, 1)

  if (userError) return <p>Error loading user data: {userError.message}</p>

  return (
    <div className='col-md-12'>
      <div className='card mb-3'>
        <div className='card-body'>
          <div className='d-flex row align-items-center'>
            {userLoading ? (
              <div>
                <Spinner marginSize='40px' />
              </div>
            ) : (<>
              <div className='card-title d-flex flex-column fw-bold text-white'>
                <p className="text-end rfs-4">{date.toLocaleDateString()} - {date.toLocaleTimeString()}</p>
                <p className='rfs-3'>
                  <span className="cursor-pointer" onClick={() => navigate(`/posts/${post.id}`)}>@{userData.userProfile.username}</span>
                </p>
              </div>

              <p className='card-text rfs-3'>{post.content}</p>

              {post.imageUrl && (
                <img
                  src={post.imageUrl}
                  className='my-2 mx-auto w-75 vh-75'
                  //style={{ width: '70%', height: '70%' }}
                  alt=''
                />
              )}

              <div className="d-flex justify-content-between">
                <div className="w-100">
                  <AddLikeButton postId={post.id} />
                  <AddCommentButton postId={post.id} />
                </div>

                <div>
                  <SavePostButton postId={post.id} />
                </div>
              </div>

              <div className='d-flex row justify-content-center'>
                {commentsToShow.map((comment, index) => (
                  <Comment key={index} comment={comment} refetchPost={refetch} />
                ))}

                {comments.length > 1 && (
                  <div className='text-center btn-link rfs-5 text-rose'>
                    <span className="cursor-pointer" onClick={handleShowMoreComments}>{showAllComments ? 'Show Less' : 'Show More'}</span>
                  </div>
                )}
              </div>
            </>)}
          </div>
        </div>
      </div>
    </div>
  )
}

// userId: 660470230f3193a5b626785f
// postId: 660470760f3193a5b6267863